<template>
  <tenant-form :tenant-id="$route.params.id" @submit="update" />
</template>

<script>
import { storage } from 'firebase/app';
import 'firebase/storage';
import { db } from '@/plugins/firebase';
import TenantForm from './TenantForm.vue';

export default {
  name: 'EditTenant',
  components: { TenantForm },
  methods: {
    async update(image, tenant) {
      const toUpdate = [];
      if (image) {
        toUpdate.push(
          storage()
            .ref(`tenants/${this.$route.params.id}`)
            .put(image),
        );
      }
      toUpdate.push(
        db
          .collection('users')
          .doc(this.$route.params.id)
          .update(tenant),
      );
      await Promise.all(toUpdate);
      this.$router.push('../tenants');
    },
  },
};
</script>

<style></style>
